/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { Icon, mergeStyleSets } from '@fluentui/react';
import { useContext } from "react";
import { components } from "react-select";
import { Select } from "../select/Select";
import { ColumnOptionsContext } from "./ColumnOptions";

const classNames = mergeStyleSets({
  option: {
    display: "flex",
    alignItems: "center",
    overflow: "auto"
  }
});

export const ViewSelect = ({ className }: { className?: string }) => {
  const {
    views,
    selectedView,
    isViewLoading,
    onChangeView,
    strings,
    hideViewOptionsFeatures,
    usePlaceholder,
    id
  } = useContext(ColumnOptionsContext);

  const options = views.map(s => {
    return {
      label: s.userAppSettingName,
      value: s.userAppSettingId,
      isDefault: s.isDefault
    };
  });

  let selectedOption = null;
  if (selectedView !== null && selectedView !== undefined) {
    selectedOption = {
      value: selectedView.userAppSettingId,
      label: selectedView.userAppSettingName,
      isDefault: selectedView.isDefault
    };
  }
  //
  else if (!usePlaceholder) {
    selectedOption = {
      value: "default",
      label: "Default"
    };
  }

  const isLoading = isViewLoading;
  const isDisabled = isLoading;

  return (
    <div className={className}>
      {!hideViewOptionsFeatures && (
        <Select
          value={selectedOption}
          onChange={(o: any) => {
            onChangeView(o ? o.value : null);
          }}
          options={options}
          noOptionsMessage={() => strings.viewSelectNoViewsLabel}
          placeholder={strings.viewSelectPlaceholder}
          isSearchable={options.length > 8}
          isClearable={!!selectedView}
          loadingMessage={() => strings.viewSelectLoadingLabel}
          isDisabled={isDisabled}
          isLoading={isLoading}
          components={{
            Option: CustomOption,
            SingleValue: CustomSingleValue
          }}
          id={id ? `${id}-view-select` : undefined}
          className="view-select"
        />
      )}
    </div>
  );
};

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}  >
      <div className={classNames.option}>
        {props.data.isDefault && <StarIcon iconName="FavoriteStarFill"/>}
        {props.children}
      </div>
    </components.Option>
  );
};

const CustomSingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <div
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        {props.data.isDefault && <StarIcon iconName="FavoriteStarFill" />}
        {props.children}
      </div>
    </components.SingleValue>
  );
};

const StarIcon = styled(Icon)`
  color: ${p => p.theme.palette.themePrimary};
  margin-right: 6px;
`;
